let instance = null;
import SmoothScroll from '../utils/SmoothScroll'
import Accordion from '../components/Accordion';
import HtmlVideoPlayer from '../components/HtmlVideoPlayer';
import VimeoVideoPlayer from '../components/VimeoVideoPlayer';
import Nav from '../components/Nav';
import PageObserver from '../components/PageObserver';
import BlockObserver from '../components/BlockObserver';
// import '../components/CookiesConsent';
import LoadPost from '../components/loadPosts'
import ImageParallax from '../components/ImageParallax';
import MediaGallery from "../components/MediaGallery";
import Testimonials from "../components/Testimonials";
import WhatWeDo from "../components/WhatWeDo";
import TheProcess from "../components/TheProcess";
import PostsCarousel from "../components/PostsCarousel";
import LogoCarousel from "../components/LogoCarousel";
import GetStarted from "../components/GetStarted";
import TaggedAccordion from "../components/TaggedAccordion";
import VisualAccordion from "../components/VisualAccordion";
import NumberCounter from "../components/NumberCounter";

import { disableGravityFormsSubmitButtonWhileSubmitting } from "../utils/utils";

export default class App {
	constructor() {

		// ============================================================================================
		// SETUP APP
		// ============================================================================================

		// Create singleton
		if (instance) {
			return instance;
		}
		instance = this;


		// Create global access
		window.app = this;


		// Get context
		this.getContext();
		window.addEventListener('resize', () => {
			this.getContext();
		});


		// ============================================================================================
		// GLOBAL FUNCTIONS
		// ============================================================================================

		this.pageObserver = new PageObserver()
		this.blockObserver = new BlockObserver(document.querySelectorAll('[data-watch="true"]'))
		this.loadPosts = new LoadPost();
		this.imageParallax = new ImageParallax();
		this.nav = new Nav();
		this.mediaGallery = new MediaGallery();

		// SETTING UP SMOOTH SCROLLING
		this.smoothScroll = new SmoothScroll()

		disableGravityFormsSubmitButtonWhileSubmitting()


		// ============================================================================================
		// COMPONENTS
		// ============================================================================================

		this.accordions = document.querySelectorAll('[data-component="accordion"]');
		this.accordions && this.accordions.forEach((accordion) => {
			new Accordion(accordion).init();
		})

		this.mediaGalleries = document.querySelectorAll('[data-component="media-gallery"]');
		this.mediaGalleries && this.mediaGalleries.forEach((mediaGallery) => {
			new MediaGallery(mediaGallery).init();
		})

		this.getStartedBlocks = document.querySelectorAll('[data-component="get-started"]');
		this.getStartedBlocks && this.getStartedBlocks.forEach((getStarted) => {
			new GetStarted(getStarted).init(getStarted);
		})

		this.testimonials = document.querySelectorAll('[data-component="testimonials"]');
		this.testimonials && this.testimonials.forEach((testimonial) => {
			new Testimonials(testimonial).init(testimonial);
		})

		this.listSlideshows = document.querySelectorAll('[data-component="list-slideshow"]');
		this.listSlideshows && this.listSlideshows.forEach((slideshow)=>{
			new VisualAccordion(slideshow);
		})

		this.statistics = document.querySelectorAll('.statistics__statistics');
		this.statistics && this.statistics.forEach(stats => {
			new NumberCounter(stats);
		})

		this.whatWeDo = document.querySelectorAll('[data-component="whatwedo"]');
		this.whatWeDo && this.whatWeDo.forEach((whatWeDo) => {
			new WhatWeDo(whatWeDo).init(whatWeDo);
		})

		this.theProcess = document.querySelectorAll('[data-component="theprocess"]');
		this.theProcess && this.theProcess.forEach((theProcess) => {
			new TheProcess(theProcess).init(theProcess);
		})

		this.postsCarousels = document.querySelectorAll('[data-component="postscarousel"]');
		this.postsCarousels && this.postsCarousels.forEach((postsCarousel) => {
			new PostsCarousel(postsCarousel).init(postsCarousel);
		})

		document.querySelectorAll('.b-logos').forEach(block => {
			new LogoCarousel(block).init(block);
		})

		this.taggedAccordions = document.querySelectorAll('[data-component="taggedaccordion"]');
		this.taggedAccordions && this.taggedAccordions.forEach((taggedAccordion) => {
			new TaggedAccordion(taggedAccordion).init(taggedAccordion);
		})

		this.footerMenuItems = document.querySelectorAll('.footer__menu .menu-item-has-children');
		this.footerMenuItems && this.footerMenuItems.forEach((menuItem) => {
			menuItem.addEventListener('click', function (e) {
				this.footerMenuItems = document.querySelectorAll('.footer__menu .menu-item-has-children');
				this.footerMenuItems && this.footerMenuItems.forEach((menuItemNew) => {
					menuItemNew.classList.remove('open');
				})
				menuItem.classList.add('open');
			})
		})

		this.onboardingToggle = document.querySelectorAll('.button--onboarding');
		this.onboardingToggle && this.onboardingToggle.forEach((button) => {
			button.addEventListener('click', function (e) {
				e.preventDefault();
				this.onboardingShell = document.querySelector('.onboarding__shell');
				this.onboardingShell.classList.toggle('onboarding__shell--open');
				document.body.classList.toggle('onboarding--open');
				document.querySelector('body').classList.remove('nav--open');
				if(!button.hasAttribute("data-lenis-ignore") && window.app.smoothScroll.lenis) {
					if(window.app.smoothScroll.lenis.isStopped == true) {
						window.app.smoothScroll.lenis.start()
					} else {
						window.app.smoothScroll.lenis.stop()
					}
				}
			})
		})

		this.onboardingOptions = document.querySelectorAll('.landing__option');
		this.onboardingOptions && this.onboardingOptions.forEach((button) => {
			button.addEventListener('click', function (e) {
				this.onboardingOptions = document.querySelectorAll('.landing__option');
				this.onboardingOptions && this.onboardingOptions.forEach((button) => {
					button.classList.remove('selected');
				})
				button.classList.add('selected');
				//document.getElementById('onboarding--start').disabled = false;
				//document.getElementById('onboarding--start').dataset.formtoshow = button.dataset.formtoshow;
			})
		})

		this.onboardingOptions = document.querySelectorAll('.landing__options .landing__option');
		this.onboardingOptions && this.onboardingOptions.forEach((onboardingOption) => {
			onboardingOption.addEventListener('click', function (e) {
				let formID = onboardingOption.getAttribute('data-formtoshow');
				document.querySelector('[data-form="'+formID+'"]').classList.add('form__wrapper--visible');
				document.querySelector('.form__landing').classList.remove('form__wrapper--visible');
			});
		})

		this.firstPages = document.querySelectorAll('.onboarding__shell .gform_body .gform_page:first-of-type');
		this.firstPages && this.firstPages.forEach((firstPage) => {
			firstPage.querySelector('.gform_page_footer').insertAdjacentHTML('afterbegin', '<input type="button" value="Go back" class="gform_previous_button reset--onboarding">');
		})


		this.resetOnboarding = document.querySelectorAll('.reset--onboarding');
		this.resetOnboarding && this.resetOnboarding.forEach((resetOnboarding) => {
			resetOnboarding.addEventListener('click', function (e) {
				document.querySelectorAll('[data-form]').forEach((onboardingForm) => {
					onboardingForm.classList.remove('form__wrapper--visible');
				})
				document.querySelector('.form__landing').classList.add('form__wrapper--visible');
			});
		})

		this.htmlVideos = document.querySelectorAll('.video--html');
		this.htmlVideos && this.htmlVideos.forEach((video) => {
			let options =
			{
				autoplay: false,
				loop: true,
				muted: true,
				controls: true,
				progress: true,
			}

			new HtmlVideoPlayer(video, options);

		})

		this.vimeoVideos = document.querySelectorAll('.video--vimeo');
		this.vimeoVideos && this.vimeoVideos.forEach((video) => {
			let options =
			{
				autoplay: false,
				loop: true,
				muted: true,
				controls: true,
				progress: true,
			}
			new VimeoVideoPlayer(video, options);
		})

		// For positioning offset border behind the relevant block
		this.singleResources = document.querySelector('.single-resources');

		if(this.singleResources) {
			let firstImageBlock = document.getElementsByClassName('resource__block-image')[0];
			if(firstImageBlock) {
				let colourSpan = document.createElement('span');
				colourSpan.classList.add('background--ivory-tint');
				colourSpan.classList.add('colour-sep');
				document.getElementById('main').appendChild(colourSpan)
				addEventListener("scroll", (event) => {
					if(firstImageBlock.classList.contains('visible')) {
						let elDistanceToTop = window.scrollY + firstImageBlock.getBoundingClientRect().top + firstImageBlock.getBoundingClientRect().height / 2;
						let mainHeight = document.getElementById('main').getBoundingClientRect();
						let requiredHeight = mainHeight.height - elDistanceToTop;
						colourSpan.style.top = elDistanceToTop + 'px';
						colourSpan.style.height = requiredHeight + 'px';
					}
				});
			}
		}

		document.querySelectorAll('img') && document.querySelectorAll('img').forEach((img) => {
			img.addEventListener("contextmenu", (e) => {e.preventDefault()});
		});

		document.querySelectorAll('[data-img-block]') && document.querySelectorAll('[data-img-block]').forEach((img) => {
			img.addEventListener("contextmenu", (e) => {e.preventDefault()});
		});

		this.mobileMenuItems = document.querySelectorAll('#what-we-do-menu a, #what-we-do-menu button');
		this.mobileMenuItems && this.mobileMenuItems.forEach((menuButton) => {
			menuButton.addEventListener('click', (event) => {
				if(menuButton.classList.contains('selected')) {
					event.preventDefault();
					document.querySelector('#what-we-do-menu').classList.toggle('what-we-do-menu--opened');
				} else {
					this.mobileMenuItems.forEach((button) => {
						button.classList.remove('selected');
					});
					menuButton.classList.add('selected');
					document.querySelector('#what-we-do-menu').classList.remove('what-we-do-menu--opened');
				}
			});
		});

	}
	getContext() {
		// Tells us if App is Mobile

		if (window.matchMedia('(max-width: 1024px)').matches) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}

		if (window.matchMedia('(hover: none)').matches) {
			this.isTouch = true;
		} else {
			this.isTouch = false;
		}

		if (window.location.host.includes('localhost')) {
			this.URL =
				'http://' +
				window.location.host +
				`/${REPO}/wp-content/themes/${THEME}`;
		} else {
			this.URL =
				'https://' + window.location.host + `/wp-content/themes/${THEME}`;
		}

	}
}
